import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import variant from '@styled-system/variant';
import { ACURA_SITE_NAME } from '../../../utils/constants';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Wrapper')(
  ({ isSelected }) =>
    css({
      display: 'flex',
      flexDirection: 'column',
      width: ['280px', '280px', '304px'],
      border: 1,
      borderColor: isSelected ? 'blues.1' : 'grey.2',
      backgroundColor: isSelected && 'notification.information.2',
      padding: 'default',
      mb: 'm',
      gap: 'm',
      '&:hover': {
        bg: isSelected ? 'notification.information.1' : 'grey500',
      },
      borderRadius: '3px', // default value
    }),
  variant({
    variants: {
      [ACURA_SITE_NAME]: {
        borderRadius: '8px',
      },
    },
  }),
);

themeStyles.addBaseStyles('AddressWrapper')(
  css({
    display: 'flex',
    width: ['232px', '232px', '256px'],
    flexDirection: 'column',
    gap: 'xxs',
  }),
);

themeStyles.addBaseStyles('HeaderWrapper')(
  css({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 's',
  }),
);

themeStyles.addBaseStyles('DealerName')(
  css({
    fontFamily: 'bold',
    width: ['110px', '110px', '122px'],
  }),
);

themeStyles.addBaseStyles('Distance')(
  css({
    color: 'blackSolidShades.1',
    width: ['110px', '110px', '122px'],
    fontSize: '12px',
    lineHeight: ['18px', '18px', '16px'],
    textAlign: 'right',
  }),
);

themeStyles.addBaseStyles('CTA')(({ theme }) =>
  css({
    display: 'block',
    width: '100%',
    lineHeight: '19px',
    '&:focus-visible': {
      outline: `solid 8px ${theme.colors.aodaFocused}`,
      outlineOffset: '-8px',
    },
  }),
);

export default themeStyles;
